
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"11.5","stroke":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M11.903 12.544h.094c.849-.015 1.536-.314 2.043-.885 1.116-1.258.93-3.415.91-3.62-.072-1.546-.803-2.285-1.406-2.63A3.224 3.224 0 0011.984 5h-.049c-.321 0-.954.052-1.56.397-.608.345-1.35 1.084-1.423 2.641-.02.206-.206 2.363.91 3.621.505.571 1.192.87 2.041.885zM9.726 8.11c0-.009.003-.018.003-.023.096-2.08 1.571-2.302 2.204-2.302h.034c.783.017 2.114.336 2.204 2.302 0 .008 0 .017.003.023.002.02.205 1.991-.717 3.03-.365.411-.852.614-1.493.62H11.935c-.638-.006-1.127-.209-1.49-.62-.919-1.033-.722-3.013-.719-3.03z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M17.908 16.121v-.008c0-.024-.003-.047-.003-.073-.018-.574-.055-1.916-1.314-2.345l-.029-.01c-1.307-.333-2.394-1.086-2.406-1.095a.39.39 0 10-.45.64c.05.035 1.204.839 2.648 1.21.675.24.75.962.77 1.623 0 .026 0 .05.004.073a5.26 5.26 0 01-.061.896c-.47.266-2.31 1.188-5.111 1.188-2.79 0-4.642-.925-5.114-1.191a4.982 4.982 0 01-.061-.896c0-.023.003-.047.003-.073.02-.66.095-1.383.77-1.623 1.445-.371 2.598-1.177 2.648-1.21a.39.39 0 10-.45-.64c-.011.009-1.093.763-2.406 1.096l-.029.009c-1.258.432-1.296 1.774-1.313 2.345 0 .026 0 .05-.003.073v.008c-.003.151-.006.925.148 1.314.029.075.08.139.15.182.087.058 2.172 1.386 5.66 1.386 3.487 0 5.572-1.33 5.659-1.386a.387.387 0 00.15-.182c.145-.386.142-1.16.14-1.31z","fill":"#00003C"}})])
          )
        }
      }
    